import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      padding: [20, 0, 48],
      [theme.breakpoints.up("mobile")]: {
        padding: [29, 0, 72],
      },
      [theme.breakpoints.up("tablet")]: {
        padding: [31, 0, 72],
      },
      "& a": {
        fontSize: 0,
      },
    },
    title: {
      marginBottom: 19,
      textAlign: "center",
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 12,
        textAlign: "left",
      },
      [theme.breakpoints.up("tablet")]: {
        marginBottom: 31,
      },
    },
    categoryImage: {
      width: "100%",
    },
    hover: {
      position: "relative",
      "&::before": {
        position: "absolute",
        width: "100%",
        height: "100%",
        content: "''",
        backgroundColor: theme.palette.primary.main,
        opacity: 0,
      },
      "&:hover::before": {
        "@media (hover: hover)": {
          opacity: 0.5,
        },
      },
    },
  }),
  { name: "Categories" },
);
